import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FloatingLabel, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../components/LoadingModal.js";
import AlertModal from "../../../components/AlertModal.js";
import { FollowUpPlaceService } from "../../../services/FollowUpPlaceService.js";
import { AuthService } from "../../../services/AuthService.js";
import styles from "../../../styles/Modal.module.css";

function EditFollowUpPlaceModal({ show, onHide, followUpPlace, onClose }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [followUpPlaces, setFollowUpPlaces] = useState({ id: undefined, name: "" });
  const [error, setError] = useState({ name: "" });

  // Alert state
  const [alertData, setAlertData] = useState({
    show: false,
    title: "",
    message: "",
    variant: "success",
  });

  const validation = () => {
    let tempError = { name: "" };
    let valid = true;
    if (!followUpPlaces.name.trim()) {
      tempError.name = "Name is required";
      valid = false;
    }
    setError(tempError);
    return valid;
  };

  const updateFollowUpPlace = async () => {
    if (!validation()) return;

    setLoading(true);
    try {
      const res = await FollowUpPlaceService.updateFollowUpPlace({ ...followUpPlaces });
      if (res.status === 200) {
        onHide(); 
        if (onClose) {
          onClose({
            status: "success",
            message: res.message || "Follow Up Place updated successfully!"
          });
        }
      } else {
        throw new Error(res.message || "Error while updating Follow Up Place");
      }
    } catch (error) {
      setAlertData({
        show: true,
        title: "Error",
        message: error.message || "Failed to update Follow Up Place. Please try again.",
        variant: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAlertClose = () => {
    setAlertData((prev) => ({ ...prev, show: false }));
    if (alertData.variant === "success") {
      navigate("/followup-place");
    }
  };

  useEffect(() => {
    if (show && followUpPlace) {
      setFollowUpPlaces({ id: followUpPlace.id, name: followUpPlace.name });
    }
  }, [show, followUpPlace]);

  return (
    <>
      <Modal show={show} onHide={onHide} size="md" centered className={styles.modalShow}>
        <Modal.Header closeButton className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>
            <i className="fas fa-edit me-2"></i>
            Edit Follow Up Place
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.formGroup}>
            <FloatingLabel
              controlId="editFollowUpPlace"
              label={
                <>
                  Follow Up Place <span className="text-danger">*</span>
                </>
              }
            >
              <Form.Control
                type="text"
                placeholder="Enter Follow Up Place"
                value={followUpPlaces.name}
                onChange={(e) => setFollowUpPlaces({ ...followUpPlaces, name: e.target.value })}
                isInvalid={!!error.name}
              />
              <Form.Control.Feedback type="invalid">
                {error.name}
              </Form.Control.Feedback>
            </FloatingLabel>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          {AuthService.canUpdate() && (
            <Button
              variant="success"
              onClick={updateFollowUpPlace}
              className={styles.primaryButton}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Update Follow Up Place
                </>
              )}
            </Button>
          )}
          <Button
            variant="danger"
            onClick={onHide}
            className={styles.secondaryButton}
          >
            <i className="fas fa-times me-1"></i>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <LoadingModal show={loading} />

      {/* Alert Modal */}
      <AlertModal
        show={alertData.show}
        onHide={handleAlertClose}
        title={alertData.title}
        message={alertData.message}
        variant={alertData.variant}
      />
    </>
  );
}


function EditFollowUpPlace(props) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <FontAwesomeIcon
        icon={faEdit}
        style={{ color: '#05275a' }}
        size="lg"
        onClick={() => setModalShow(true)}
      />
      <EditFollowUpPlaceModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        followUpPlace={props.followUpPlace}
        onClose={props.onClose}
      />
    </>
  );
}

export default EditFollowUpPlace;
